// 5.0以上版本
import * as echarts from "echarts";
// import "../../node_modules/echarts/map/js/world";
// import 'echarts-gl';

const install = function (Vue) {
  Vue.prototype.$init = echarts.init;
  Object.defineProperties(Vue.prototype, {
    $echarts: {
      get() {
        return {
          barone: function (myChart, data) {
            var option = {
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  // 坐标轴指示器，坐标轴触发有效
                  type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                },
              },
              xAxis: {
                type: "category",
                data: data.xData,
                // 修改刻度标签 相关样式
                axisLabel: {
                  fontSize: "12",
                  color: "rgba(255,255,255,.6) ",
                },
                axisTick: {
                  show: false,
                },
              },
              yAxis: {
                type: "value",
                axisLabel: {
                  color: "rgba(255,255,255,.6) ",
                },
                // y轴分割线的颜色
                splitLine: {
                  lineStyle: {
                    color: "rgba(255,255,255,.1)",
                  },
                },
              },
              grid: {
                left: "3%",
                top: "5%",
                right: "3%",
                bottom: "5%",
                // 是否显示刻度标签 如果是true 就显示 否则反之
                containLabel: true,
              },
              series: [
                {
                  data: data.totalData,
                  type: "bar",
                  barWidth: "35%",
                  // 展示阴影
                  // showBackground: true,
                  color: "#2465d5",
                  itemStyle: {
                    // 修改柱子圆角
                    barBorderRadius: 5,
                  },
                },
              ],
            };
            option && myChart.setOption(option);
            window.addEventListener("resize", function () {
              myChart.resize();
            });
          },
          bartwo: function (myChart, data) {
            var option = {
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "shadow",
                },
              },
              legend: {},
              grid: {
                left: "3%",
                top: "0%",
                right: "3%",
                bottom: "2%",
                // 是否显示刻度标签 如果是true 就显示 否则反之
                containLabel: true,
              },
              xAxis: {
                type: "value",
                boundaryGap: [0, 0.01],
                splitLine: {
                  lineStyle: {
                    color: "rgba(255,255,255,.1)",
                  },
                },
                axisLine: {
                  show: false, // 去除轴线
                },
                axisLabel: {
                  color: "rgba(255,255,255,.6) ",
                },
              },
              yAxis: {
                type: "category",
                data: data.companyData,
                axisLabel: {
                  color: "rgba(255,255,255,.6) ",
                  formatter: function (value) {
                    if (value.length > 8) {
                      return `${value.slice(0, 8)}.....`;
                    }
                    return value;
                  },
                },
              },
              series: [
                {
                  type: "bar",
                  data: data.totalList,
                  barWidth: "80%",
                  itemStyle: {
                    // color: "#80B7E9",
                    barBorderRadius: [0, 20, 20, 0],
                    color: new echarts.graphic.LinearGradient(0, 0, 1, 1, [
                      {
                        offset: 0,
                        // color: "#06B5D7"
                        color: "#3e7dde",
                      },
                      { offset: 0.5, color: "#44C0C1" },
                      {
                        offset: 1,
                        color: "#4bdaeb",
                      },
                    ]),
                  },
                  backgroundStyle: {
                    // color: "rgba(180, 180, 180, 0.2)",
                  },
                },
              ],
            };
            option && myChart.setOption(option);
            window.addEventListener("resize", function () {
              myChart.resize();
            });
          },
          lineone: function (myChart, data) {
            var option = {
              color: ["#2d64d1", "#0a92b4", "#0696AB"],
              tooltip: {
                trigger: "axis",
              },
              grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true,
              },
              grid: {
                left: "2%",
                top: "4%",
                right: "3%",
                bottom: "4%",
                // 是否显示刻度标签 如果是true 就显示 否则反之
                containLabel: true,
              },
              xAxis: {
                type: "category",
                data: [1, 2, 3, 4, 5, 6, 7],
                axisTick: {
                  show: false, // 去除刻度线
                },
                axisLabel: {
                  color: "rgba(255,255,255,.6) ",
                },
              },
              yAxis: {
                type: "value",
                splitLine: {
                  lineStyle: {
                    color: "rgba(255,255,255,.1)",
                  },
                },
                axisLabel: {
                  color: "rgba(255,255,255,.6) ",
                },
              },
              series: [
                {
                  name: "近一周",
                  type: "line",
                  smooth: true,
                  stack: "Total",
                  data: data.currentWeek,
                },
                {
                  type: "line",
                  smooth: true, // 圆滑的线
                  name: "前一周",
                  data: data.lastWeek,
                },
                {
                  type: "line",
                  smooth: true, // 圆滑的线
                  name: "前两周",
                  data: data.middleWeek,
                },
              ],
            };
            option && myChart.setOption(option);
            window.addEventListener("resize", function () {
              myChart.resize();
            });
          },
          pieone: function (className, data) {
            var myChart = echarts.init(document.querySelector(className));
            var option = {
              color: ["#1867ac", "#2c77fb", "#ae29fd", "#8B78F6"],
              tooltip: {
                trigger: "item",
                // formatter: "{a} <br/>{b}: {c} ({d}%)",
              },
              legend: {
                bottom: "0%",
                // 修改小图标的大小
                itemWidth: 10,
                itemHeight: 10,
                // 修改图例组件的文字为 12px
                textStyle: {
                  color: "rgba(255,255,255,.5)",
                  fontSize: "12",
                },
              },
              series: [
                {
                  name: "文章状态",
                  type: "pie",
                  // 这个radius可以修改饼形图的大小
                  // radius 第一个值是内圆的半径 第二个值是外圆的半径
                  radius: ["40%", "60%"],
                  center: ["50%", "45%"],
                  avoidLabelOverlap: false,
                  // 图形上的文字
                  label: {
                    show: false,
                    position: "center",
                  },
                  // 链接文字和图形的线是否显示
                  labelLine: {
                    show: false,
                  },
                  data: data.pieData,
                },
              ],
            };
            option && myChart.setOption(option);
            window.addEventListener("resize", function () {
              myChart.resize();
            });
          },
          // pieTwo: function (className, data) {
          //   var myChart = echarts.init(document.querySelector(className));
          //   var option = {
          //     tooltip: {
          //       trigger: "item",
          //     },
          //     radar: {
          //       name: {
          //         textStyle: {
          //           color: "#333",
          //           fontSize: 10,
          //           backgroundColor: "#f5f5f5",
          //           borderRadius: 3,
          //           padding: [3, 5],
          //         },
          //       },
          //       indicator: [
          //         { name: "销售", max: 50 },
          //         { name: "管理", max: 5 },
          //         { name: "技术", max: 4 },
          //         { name: "客服", max: 3 },
          //         { name: "人资", max: 5 },
          //         { name: "运营", max: 10 },
          //       ],
          //       radius: 60,
          //       nameGap: 8,
          //     },
          //     series: [
          //       {
          //         name: "公司部门人员配备",
          //         type: "radar",
          //         data: [
          //           {
          //             value: [30, 3, 4, 3, 5, 8],
          //             itemStyle: {
          //               color: "#a8efeb",
          //             },
          //             areaStyle: {
          //               opacity: 0.8,
          //               color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          //                 {
          //                   offset: 0,
          //                   color: "rgba(234, 214, 238, 1)",
          //                 },
          //                 {
          //                   offset: 1,
          //                   color: "rgba(168, 239, 235, 1)",
          //                 },
          //               ]),
          //             },
          //           },
          //         ],
          //       },
          //     ],
          //   };
          //   option && myChart.setOption(option);
          //   window.addEventListener("resize", function () {
          //     myChart.resize();
          //   });
          // },
        };
      },
    },
  });
};
export default install;
